module.exports = __webpack_public_path__ + "img/fi_trash.3d1e3186.svg";